var products_on_page = $('.products-on-page');
var next_url = products_on_page.data('next-url');

var load_more_btn = $('.load-more_btn');
var load_more_spinner = $('.load-more_spinner');

function loadMoreProducts() {
  $.ajax({
    url: next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      load_more_btn.hide();
      load_more_spinner.show();
    }
  }).done(function(next_page) {
    load_more_spinner.hide();

    var new_products = $(next_page).find('.products-on-page');
    var new_url = new_products.data('next-url');

    if (new_url) {
      load_more_btn.show();
    }

    next_url = new_url;

    // Append new products to the existing products
    products_on_page.append(new_products.html());

    // Apply styles to each new ProductItem inside Grid__Cell
    var newlyAddedItems = products_on_page.find('.Grid__Cell .ProductItem');

    if (newlyAddedItems.length > 0) {
      console.log(newlyAddedItems.length + ' new ProductItems found.');

      // Reset visibility and apply styles to the newly added ProductItems
      newlyAddedItems.each(function() {
        $(this).css({
          'visibility': 'inherit',
          'opacity': '1',
          'transform': 'matrix(1, 0, 0, 1, 0, 0)'  // Resetting to initial state
        });
      });
    } else {
      console.log('No new ProductItems found.');
    }
  });
}

// Assuming you have a button or link to load more products
load_more_btn.on('click', loadMoreProducts);
